import { useContext } from 'react';
import { GlobalMobileContext } from '../../contexts/globalMobileContext';

import styles from './Mobile_ConferenceEditNotesPage.module.css'

const Mobile_ConferenceEditNotesPage = () => {
    const {  currentNote, inputNoteRef } = useContext(GlobalMobileContext);

    return (
        <div className={styles.component}>

            <textarea
                ref={inputNoteRef}
                className={styles.textAreaNotes}
                placeholder="Note"
                defaultValue={currentNote?.text || ""}
            />

        </div>
    );
}

export default Mobile_ConferenceEditNotesPage;
